import React, { useState, useEffect, useRef, useMemo, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import TextInput from "components/Input/TextInput.js";
import IntInput from "components/Input/IntInput.js";
import DateInput from "components/Input/DateInput.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import UserService from "services/UserService";
import LocalizationAutocomplete from "components/LocalizationAutocomplete/LocalizationAutocomplete";
import { ceecampaign as ceecampaigntext } from "variables/cee";
import { makeStyles } from "@mui/styles";
import { putCeecampaign, getFiles, getUsers } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import CEECampaignsContext from "context/CEECampaignsContext";
import { NotificationManager } from 'react-notifications';
import Chip from "@mui/material/Chip";
import { statusData } from "variables/lists/cee";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddContact from "./AddContact";
import ContactDialog from "./ContactDialog";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
    fontFamily: '"Source Sans Pro",sans-serif',

  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  textInput: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputImage: {
    display: "flex",
    flexDirection: "column",
    margin: "0rem 0rem 0rem",
    color: "#000000",
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: "12px",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function General(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];

  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = ceeCampaignContext;

  const ceeupdate = permis.includes("cee_admin") && ceecampaign.ceecampaignAdminVisibility;

  const [name, setName] = useState(ceecampaign.parameters.general.name);
  const [groups, setGroups] = useState(ceecampaign.parameters.general.groups);
  const [status, setStatus] = useState(ceecampaign.parameters.general.status);
  const [datebegin, setDatebegin] = useState(ceecampaign.parameters.general.datebegin);
  const [dateend, setDateend] = useState(ceecampaign.parameters.general.dateend);
  const [associateddocuments, setAssociateddocuments] = useState(ceecampaign.parameters.general.associateddocuments || []);
  const [otherfiles, setOtherfiles] = useState(ceecampaign.parameters.general.otherfiles || []);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleGroupsChange = (event) => { setGroups(event.target.value); };
  const handleStatusChange = (event) => { setStatus(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleOtherfilesChange = (event) => { setOtherfiles(event.target.value); };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    axios
      .get(getFiles(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const handleAssociateddocumentsChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setAssociateddocuments(newArray);
  };

  const selectedOtherFiles = () => {
    let gedCardId = [];
    let getGedNames;
    if (otherfiles !== undefined) {
      for (let i = 0; i < otherfiles.length; i++) {
        gedCardId.push(otherfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };
  const handleOtherFilesChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setOtherfiles(newArray);
  };

  const handleEdit = () => {
    let editedceecampaign = { ...ceecampaign };
    editedceecampaign.parameters.general = {
      ...editedceecampaign.parameters.general,
      name,
      status,
      datebegin,
      dateend,
      associateddocuments,
      otherfiles,
    };
    axios
      .put(
        putCeecampaign(ceecampaign.id),
        {
          ...editedceecampaign.parameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setCeecampaign(editedceecampaign);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();


  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <TextInput
              inputTitle={ceecampaigntext.general.name}
              textInput={name}
              handleTextInputChange={handleNameChange}
              disabled={!ceeupdate}
            />
          </div>
          <div>
            <CustomSelect
              inputTitle={ceecampaigntext.general.status}
              selectValue={status}
              handleSelectValueChange={handleStatusChange}
              data={statusData}
              disabled={!ceeupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={ceecampaigntext.general.datebegin}
              dateInput={datebegin}
              handleDateInputChange={handleDatebeginChange}
              disabled={!ceeupdate}
            />
          </div>
          <div>
            <DateInput
              inputTitle={ceecampaigntext.general.dateend}
              dateInput={dateend}
              handleDateInputChange={handleDateendChange}
              disabled={!ceeupdate}
            />
          </div>
          <div>
            <AutocompleteInput
              disabled={!ceeupdate}
              inputTitle={ceecampaigntext.general.associateddocuments}
              selected={associateddocuments}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociateddocumentsChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
          <div>
            <AutocompleteInput
              disabled={!ceeupdate}
              inputTitle={ceecampaigntext.general.otherfiles}
              selected={otherfiles}
              list={gedList}
              handleChange={(_, newValue) =>
                handleOtherFilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {ceeupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

function Ceecampaignresponsible(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = ceeCampaignContext;
  const ceeupdate = permis.includes("cee_admin") && ceecampaign.ceecampaignAdminVisibility;

  const [userlistdata, setUserlistdata] = useState([]);
  const [user, setUser] = useState({});
  const [name, setName] = useState(ceecampaign?.parameters?.ceecampaignresponsible?.name || '');
  const [inchargeuser, setInchargeuser] = useState(ceecampaign?.parameters?.ceecampaignresponsible?.inchargeuser || '');
  const [inchargename, setInchargename] = useState(ceecampaign?.parameters?.ceecampaignresponsible?.inchargename || '');
  const [address, setAddress] = useState(ceecampaign?.parameters?.ceecampaignresponsible?.address || '');
  const [phone, setPhone] = useState(ceecampaign?.parameters?.ceecampaignresponsible?.phone || '');
  const [email, setEmail] = useState(ceecampaign?.parameters?.ceecampaignresponsible?.email || '');
  const [requestemail, setRequestemail] = useState(ceecampaign?.parameters?.ceecampaignresponsible?.requestemail || '');

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleInchargenameChange = (event) => { setInchargename(event.target.value); };
  const handleAddressChange = (event) => { setAddress(event.target.value); };
  const handlePhoneChange = (event) => { setPhone(event.target.value); };
  const handleEmailChange = (event) => { setEmail(event.target.value); };
  const handleRequestemailChange = (event) => { setRequestemail(event.target.value); };

  const selectedUser = () => {
    let selected = {};
    if (user !== undefined) {
      selected = user;
    }
    return selected;
  };
  const handleUserChange = (newValue) => {
    setUser(newValue);
    setInchargeuser(newValue.id);
    setInchargename(newValue.firstname + ' ' + newValue.lastname);
    setEmail(newValue.email);
    //setMeternumber(newValue.id);
  };
  useEffect(() => {
    axios
      .get(getUsers(chartIdGroup, 'users'), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        var userlisttmp = [];
        userlisttmp = res.data.users.map((user) => {
          let newuser = { ...user };
          newuser.name = user.firstname + ' ' + user.lastname + ' (' + user.email + ')';
          return newuser;
        });
        setUserlistdata(userlisttmp || []);
        if(inchargeuser)
        {
          let usertmp = userlisttmp.find((o)=>o.id===inchargeuser);
          setUser(usertmp);
        }
      });
  }, []);

  const handleEdit = () => {
    let editedceecampaign = { ...ceecampaign };
    editedceecampaign.parameters.ceecampaignresponsible = {
      ...editedceecampaign.parameters.ceecampaignresponsible,
      name,
      inchargename,
      address,
      phone,
      email,
      requestemail,
      inchargeuser,
    };
    axios
      .put(
        putCeecampaign(ceecampaign.id),
        {
          ...editedceecampaign.parameters
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
          setCeecampaign(editedceecampaign);
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };


  const classes = useStyles();
  return (
    <div style={{ marginTop: "-15px" }}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>

          {ceeupdate &&
            <div>
              <AutocompleteInputMeters
                inputMargin={"1rem 0rem 0rem"}
                specialWidth={"99%"}
                inputTitle={ceecampaigntext.ceecampaignresponsible.inchargeuser}
                selected={selectedUser()}
                list={userlistdata}
                handleChange={(_, newValue) =>
                  handleUserChange(newValue)
                }
              />
            </div>
          }
          <div>
            <TextInput
              inputTitle={ceecampaigntext.ceecampaignresponsible.inchargename}
              textInput={inchargename}
              handleTextInputChange={handleInchargenameChange
              }
              disabled={true}
            />
          </div>

          <div>
            <TextInput
              inputTitle={ceecampaigntext.ceecampaignresponsible.email}
              textInput={email}
              handleTextInputChange={handleEmailChange}
              disabled={true}
            />
          </div>
          <div>
            <TextInput
              inputTitle={ceecampaigntext.ceecampaignresponsible.name}
              textInput={name}
              handleTextInputChange={handleNameChange}
              disabled={!ceeupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={ceecampaigntext.ceecampaignresponsible.address}
              textInput={address}
              handleTextInputChange={handleAddressChange}
              disabled={!ceeupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={ceecampaigntext.ceecampaignresponsible.phone}
              textInput={phone}
              handleTextInputChange={handlePhoneChange}
              disabled={!ceeupdate}
            />
          </div>

          <div>
            <TextInput
              inputTitle={ceecampaigntext.ceecampaignresponsible.requestemail}
              textInput={requestemail}
              handleTextInputChange={handleRequestemailChange}
              disabled={!ceeupdate}
            />
          </div>

        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {ceeupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

export { General, Ceecampaignresponsible };
